import { Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { Iteration } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

export const FilterSkeleton = () => {
  return (
    <Flex justifyContent={'space-between'} width={'100%'}>
      <Flex gap={'8px'}>
        <SkeletonComponent height="34px" width="380px" />
        <SkeletonComponent height="34px" width="200px" />
        <SkeletonComponent height="34px" width="170px" />
        <SkeletonComponent height="34px" width="170px" />
      </Flex>
      <SkeletonComponent height="34px" width="100px" />
    </Flex>
  );
};

export const TableSkeleton = () => {
  return (
    <Table className={styles['table__skeleton']} data-testid="table__schedule-ruleset-skeleton">
      <Thead>
        <Tr>
          <Th width="82px" className={styles['skeleton__head']}>
            <Flex justifyContent="space-between">
              <SkeletonComponent height="21px" width="30%" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th width="250px" className={styles['skeleton__head']}>
            <SkeletonComponent height="21px" width="20%" mb="2px" />
          </Th>
          <Th width="124px" className={styles['skeleton__head']}>
            <Flex justifyContent="space-between">
              <SkeletonComponent height="21px" width="50%" mb="2px" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th width="90px" className={styles['skeleton__head']}>
            <Flex justifyContent="space-between">
              <SkeletonComponent height="21px" width="50%" mb="2px" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th width="142px" className={styles['skeleton__head']}>
            <Flex justifyContent="space-between">
              <SkeletonComponent height="21px" width="50%" mb="2px" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th width="106px" className={styles['skeleton__head']}>
            <Flex justifyContent="center">
              <SkeletonComponent height="21px" width="30%" mb="2px" />
            </Flex>
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        <Iteration
          items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
          render={(num) => {
            return (
              <Tr key={num}>
                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td className={styles['skeleton__column']}>
                  <Flex gap="4px">
                    <SkeletonComponent height="21px" width="30%" mb="2px" />
                    <SkeletonComponent height="21px" width="20%" mb="2px" />
                  </Flex>
                </Td>
                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>
                <Td className={styles['skeleton__column']}>
                  <Flex gap="4px" justifyContent="center">
                    <SkeletonComponent height="32px" width="32px" borderRadius="8px" />
                    <SkeletonComponent height="32px" width="32px" borderRadius="8px" />
                  </Flex>
                </Td>
              </Tr>
            );
          }}
        />
      </Tbody>
    </Table>
  );
};
